import {
  MenuImperative,
  useMenuImperativeControlNavigation,
} from './MenuImperative'
import type { MenuRef, Selection } from './MenuImperative.types'
import { menuItemsWrapperAttribute } from './sensors'

export {
  MenuImperative,
  useMenuImperativeControlNavigation,
} from './MenuImperative'
export type { MenuRef, Selection } from './MenuImperative.types'
export { menuItemsWrapperAttribute } from './sensors'

/**
 * @deprecatedSince 12.31.0
 * @deprecated Please use `MenuImperative` instead
 */
export const UNSAFE_Menu = MenuImperative
/**
 * @deprecatedSince 12.31.0
 * @deprecated Please use `useMenuImperativeControlNavigation` instead
 */
export const UNSAFE_useMenuImperativeControlNavigation =
  useMenuImperativeControlNavigation

/**
 * @deprecatedSince 12.30.1
 * @deprecated Please use `menuItemsWrapperAttribute` instead
 */
export const UNSAFE_menuItemsWrapperAttribute = menuItemsWrapperAttribute

/**
 * @deprecatedSince 12.30.1
 * @deprecated Please use `MenuRef` instead
 */
export interface UNSAFE_MenuRef extends MenuRef {}

/**
 * @deprecatedSince 12.30.1
 * @deprecated Please use `Selection` instead
 */
export interface UNSAFE_MenuSelection extends Selection {}
